var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ion-wrap"},[_vm._m(0),_vm._t("default")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-title"},[_c('i',{staticClass:"t-icon"}),_vm._v(" 短信记录 ")])
}]

export { render, staticRenderFns }